import { useMemo } from "react";
import { useRiskStore } from "../../../_store/riskStore";
import { cn } from "../../../utils/useFunctions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import { STYLE_PAGE, STYLE_PDF_TEXT_NORMAL_10 } from "../styles/pdf.style";
import {
  DisableCheckBalance,
  DisableInsurancePDF,
  HealthCheckBalance,
  HealthCheckPDF,
  LifeInsuranceBalance,
  LifeInsurancePDF,
} from "../../../functions/pdfGenerateFunction/riskManagePDF";
import numeral from "numeral";

function PdfPageRiskTwo({ page, balanceData, insuranceData, order= 1 }) {
  const riskData = useRiskStore((state) => state.riskData);

  const hasAccidentInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) =>
      thisItem?.options_expenses_fixed === "expenses_insuarant_accident"
  );

  const accidentInsurancValue = balanceData?.expenses_fixed_list
    ?.find(
      (thisItem) =>
        thisItem?.options_expenses_fixed === "expenses_insuarant_accident"
    )
    ?.expenses_insuarant_accidents?.reduce((acc, num) => {
      return acc + Number(num?.insurance_fund || 0);
    }, 0);

  const hasFireInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) => thisItem?.options_expenses_fixed === "expenses_insuarant_fire"
  );

  const fireInsuranceValue = balanceData?.expenses_fixed_list
    ?.find(
      (thisItem) =>
        thisItem?.options_expenses_fixed === "expenses_insuarant_fire"
    )
    ?.expenses_insuarant_fires?.reduce((acc, num) => {
      return acc + Number(num?.insurance_fund || 0);
    }, 0);

  const hasCarInsurance = balanceData?.expenses_fixed_list?.some(
    (thisItem) => thisItem?.options_expenses_fixed === "expenses_insuarant_car"
  );

  const carInsuranceValue = balanceData?.expenses_fixed_list
    ?.find(
      (thisItem) =>
        thisItem?.options_expenses_fixed === "expenses_insuarant_car"
    )
    ?.expenses_insuarant_cars?.reduce((acc, num) => {
      return acc + Number(num?.insurance_fund || 0);
    }, 0);

  // dead
  const getRiskText = () => {
    if (riskData?.dead_sum_score === 1) {
      return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    } else if (riskData?.dead_sum_score === 1.5) {
      return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    } else if (riskData?.dead_sum_score === 2) {
      return `จากการทำแบบประเมิน แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันชีวิตและประกันอุบัติเหตุ`;
    } else if (riskData?.dead_sum_score === 2.5) {
      return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    }
  };

  // sick
  const getSickText = () => {
    if (!riskData?.sick_sum_score) return "-";
    return `จากการทำแบบประเมินแนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันชีวิตและประกันอุบัติเหตุ`;
  };
  const getSickDesc = () => {
    if (riskData?.sick_sum_score === 1) {
      return `จากการทำแบบประเมินแนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันสุขภาพ ถ้าท่านสุขภาพไม่ดีเกิดการเจ็บป่วยก่อนการทำประกัน บริษัทประกันจะปฏิเสธการรับประกันท่านในโรคที่เป็นมาก่อนและภาวะสืบเนื่อง`;
    } else if (riskData?.sick_sum_score === 1.5) {
      return `จากการทำแบบประเมินแนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันสุขภาพ ถ้าท่านสุขภาพไม่ดีเกิดการเจ็บป่วยก่อนการทำประกัน บริษัทประกันจะปฏิเสธการรับประกันท่านในโรคที่เป็นมาก่อนและภาวะสืบเนื่อง`;
    } else if (riskData?.sick_sum_score === 2) {
      return `จากการทำแบบประเมินแนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันสุขภาพ ดูแลสุขภาพตนเอง ทานอาหารให้ครบ 5 หมู่ ออกกำลังกายอย่างสม่ำเสมอ พักผ่อนให้เพียงพอ อยู่ในสภาพแวดล้อมที่ดี ฝึกทำสมาธิ ดูแลสติให้อยู่ในปัจจุบัน ทำจิตใจให้เบิกบาน`;
    } else if (riskData?.sick_sum_score === 2.5) {
      // return `จากกาารทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันสุขภาพ ดูแลสุขภาพตนเอง ทานอาหารให้ครบ 5 หมู่ ออกกำลังกายอย่างสม่ำเสมอ พักผ่อนให้เพียงพอ อยู่ในสภาพแวดล้อมที่ดี ฝึกทำสมาธิ ดูแลสติให้อยู่ในปัจจุบัน ทำจิตใจให้เบิกบาน`;
      return `จากการทำแบบประเมิน โอนความเสี่ยง ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันสุขภาพ ดูแลสุขภาพตนเอง ทานอาหารให้ครบ 5 หมู่ ออกกำลังกายอย่างสม่ำเสมอ พักผ่อนให้เพียงพอ อยู่ในสภาพแวดล้อมที่ดี ฝึกทำสมาธิ ดูแลสติให้อยู่ในปัจจุบัน ทำจิตใจให้เบิกบาน`;
    } else {
      return "";
    }
  };

  // disabled
  const getDisabledText = () => {
    if (!riskData?.accident_sum_score) return "-";

    if (riskData?.disable_sum_score === 1) {
      return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    }

    if (riskData?.disable_sum_score === 1.5) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสมท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    }

    if (riskData?.disable_sum_score === 2) {
      return `จากการทำแบบประเมิน แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันทุพพลภาพ`;
    }

    if (riskData?.disable_sum_score === 2.5) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันการทุพพลภาพ`;
    }
  };

  // accident
  const getAccidentText = () => {
    if (!riskData?.accident_sum_score) return "-";
    // return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;

    if (riskData?.accident_sum_score === 1) {
      return `จากการทำแบบประเมิน ท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    }

    if (riskData?.accident_sum_score === 1.5) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสมท่านมีความสามารถในการรับความเสี่ยงไว้เองได้`;
    }

    if (riskData?.accident_sum_score === 2) {
      return `จากการทำแบบประเมิน แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันอุบัติเหตุ`;
    }

    if (riskData?.accident_sum_score === 2.5) {
      return `จากการทำแบบประเมิน 'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วยการทำประกันการอุบัติเหตุ`;
    }
  };

  // risk_car_accident
  const getCarAccidentText = () => {
    if (!riskData?.car_accident_sum_score) return "-";
    return `จากการทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงด้วยการ โอนความเสี่ยง`;
  };

  const getCarAccidentDesc = () => {
    if (!riskData?.car_accident_sum_score) return "";
    return " จากการทำแบบประเมิน 'โอนความเสี่ยง' จากกาารทำแบบประเมิน ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วย การทำประกันภัยภาคบังคับ พ.ร.บ.";
    // return "'โอนความเสี่ยง' ท่านเลือกวิธีจัดการความเสี่ยงได้เหมาะสม แนะนำให้ท่านโอนความเสี่ยงด้วย การทำประกันภัยภาคบังคับ พ.ร.บ.";
  };

  const riskItems = useMemo(() => {
    const newRiskItems = [
      {
        label: "กรณีเสียชีวิต",
        icon: "risk_dead.svg",
        title: getRiskText(),
        desc: "",
      },
      {
        label: "กรณีเจ็บป่วย",
        icon: "risk_sick.svg",
        title: getSickText(),
        desc: getSickDesc(),
      },
      {
        label: "กรณีทุพพลภาพ",
        icon: "risk_diabled.svg",
        title: getDisabledText(),
        desc: "",
      },
      {
        label: "กรณีอุบัติเหตุ",
        icon: "risk_accident.svg",
        title: getAccidentText(),
        desc: "",
      },
      {
        label: "กรณีอุบัติเหตุทางรถยนต์",
        icon: "risk_car_accident.svg",
        title: getCarAccidentText(),
        desc: getCarAccidentDesc(),
      },
    ];
    return newRiskItems;
  }, [riskData]);

  const insuranceItems = useMemo(() => {
    // console.log("DisableCheckBalance(balanceData)", DisableCheckBalance(balanceData));

    const newInsuranceItems = [
      {
        label: "ประกันชีวิต",
        icon: "insurance_life.svg",
        value_more:
          LifeInsurancePDF(insuranceData) < 0 ||
          LifeInsuranceBalance(balanceData) > 0
            ? `ประกันชีวิตควรซื้อเพิ่มอีกอย่างน้อย  ${numeral(
                Math.abs(LifeInsurancePDF(insuranceData))
              ).format("0,0")} บาท เพื่อให้คนที่คุณรักและห่วงใยดำรงชีพต่อไปได้`
            : ``,
        desc:
          LifeInsuranceBalance(balanceData) > 0 ? (
            <>
              {LifeInsurancePDF(insuranceData) < 0 ? (
                <>
                  <div className="text-start">
                    {`ควรทบทวนประกันชีวิตว่ามีเพียงพอหรือไม่ ถ้ายังไม่เพียงพอ เบี้ยประกันชีวิตหลักพัน คุ้มครองหลักแสน เบี้ยประกันหลักหมื่นคุ้มครองหลักล้าน `}
                  </div>
                </>
              ) : (
                <>
                  {`คุณรักครอบครัวมาก มีการคุ้มครองมาดีแล้วหากต้องคุ้มครองเป็นกองมรดกเพิ่ม ก็แล้วแต่ความเห็นสมควร`}
                </>
              )}
            </>
          ) : (
            <>
              <div className="text-start">{`คุณลืมกรอกข้อมูลค่าเบี้ยประกันชีวิต หรือไม่ ถ้าคุณไม่ได้ซื้อประกันชีวิต หากเกิดเหตุไม่คาดฝันขึ้นมาคนที่คุณรักและห่วงใยจะดำรงชีพต่อไปได้อย่างไร  เบี้ยประกันชีวิตหลักพันคุ้มครองหลักแสน เบี้ยประกันหลักหมื่นคุ้มครองหลักล้าน `}</div>
              <div>{`**กรอกข้อมูลได้ที่รายจ่ายคงที่ > ค่าเบี้ยประกันชีวิตรายปี > ทุนประกัน**`}</div>
            </>
          ),
      },
      {
        label: "ประกันทุพพลภาพ",
        icon: "risk_diabled.svg",
        value_more:
          Number(
            HealthCheckPDF(balanceData)?.contract_tpd +
              HealthCheckPDF(balanceData)?.aia_mutiplay_ci_more +
              HealthCheckPDF(balanceData)?.aia_total_care_more +
              HealthCheckPDF(balanceData)?.compensation_ecir +
              HealthCheckPDF(balanceData)?.compensation_aia_supercare +
              HealthCheckPDF(balanceData)?.compensation_aia_procare +
              HealthCheckPDF(balanceData)?.compensation_aia_ci_plus_gold +
              HealthCheckPDF(balanceData)?.compensation_aia_ci_plus +
              HealthCheckPDF(balanceData)?.compensation_aia_ci_topup +
              HealthCheckPDF(balanceData)?.compensation_mutiple_care_ci +
              HealthCheckPDF(balanceData)?.critical_illness_insurance_yearly_ci
          ) <= 0 ? (
            <>
              <div className="text-start">
                {`คุณลืมกรอกข้อมูลค่าเบี้ยประกันชีวิตหรือไม่ ถ้าคุณไม่ได้ซื้อประกันสุขภาพ หากเกิดเหตุไม่คาดฝันขึ้นมา เจ็บป่วยครั้งเดียวแทบหมดตัว  เบี้ยประกันสุขภาพหลักพัน คุ้มครองหลักแสน เบี้ยประกันหลักหมื่นคุ้มครองหลักล้าน`}
              </div>
              <div>{`**กรอกข้อมูลได้ที่รายจ่ายคงที่ > ค่าเบี้ยประกันชีวิตรายปี > รายละเอียดเพิ่มเติม > ตามข้อมูลที่มีดอกจัน 1 ดอก**`}</div>
            </>
          ) : (
            <div className="flex flex-col items-start ">
              <div className="!font-medium ">{`สัญญาเพิ่มเติมกรณีทุพพลภาพ (TPD) ${numeral(
                HealthCheckPDF(balanceData)?.contract_tpd
              ).format("0,0")} บาท   `}</div>{" "}
              <div className="!font-medium ">
                {`
                        สัญญาเพิ่มเติม เอไอเอ มัลติเพย์ ซีไอ ${numeral(
                          HealthCheckPDF(balanceData)?.aia_mutiplay_ci_more
                        ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className="!font-medium ">
                {`
                        สัญญาเพิ่มเติม เอไอเอ โทเทิล แคร์ ${numeral(
                          HealthCheckPDF(balanceData)?.aia_total_care_more
                        ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className="!font-medium ">
                {`
                        ค่าชดเชยโรคร้ายแรงต่อเนื่อง (ECIR) ไม่มีเงินคืน ${numeral(
                          HealthCheckPDF(balanceData)?.compensation_ecir
                        ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className="!font-medium ">
                {`
                        ค่าชดเชยโรคร้ายแรง (AIA Supercare) มีเงินคืน ${numeral(
                          HealthCheckPDF(balanceData)
                            ?.compensation_aia_supercare
                        ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className="!font-medium ">
                {`
                        ค่าชดเชยโรคร้ายแรง (AIA ProCare) มีเงินคืน ${numeral(
                          HealthCheckPDF(balanceData)?.compensation_aia_procare
                        ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className="!font-medium ">
                {`
                        ค่าชดเชยโรยร้ายแรง (AIA CI Plus Gold) ไม่มีเงินคืน ${numeral(
                          HealthCheckPDF(balanceData)
                            ?.compensation_aia_ci_plus_gold
                        ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className="!font-medium ">
                {`
                        ค่าชดเชยโรยร้ายแรง (AIA CI Plus) ไม่มีเงินคืน ${numeral(
                          HealthCheckPDF(balanceData)?.compensation_aia_ci_plus
                        ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className="!font-medium ">
                {`
                        บันทึก ซีไอท๊อปอัพ (แนบกับซีไอพลัส) ${numeral(
                          HealthCheckPDF(balanceData)?.compensation_aia_ci_topup
                        ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className="!font-medium ">
                {`
                        ค่าชดเชยโรยร้ายแรง (Mutiple Care CI) ไม่มีเงินคืน ${numeral(
                          HealthCheckPDF(balanceData)
                            ?.compensation_mutiple_care_ci
                        ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className="!font-medium ">
                {`
                        ประกันภัยโรคร้ายแรงแบบซีไอรายปี ${numeral(
                          HealthCheckPDF(balanceData)
                            ?.critical_illness_insurance_yearly_ci
                        ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className={"flex flex-wrap justify-start"}>
                ควรทบทวนประกันสุขภาพว่ามีเพียงพอหรือไม่ ถ้ายังไม่เพียงพอ
                เบี้ยประกันสุขภาพหลักพัน คุ้มครองหลักแสน
              </div>
            </div>
          ),
        //   (DisableInsurancePDF(insuranceData) < 0 || !DisableInsurancePDF(insuranceData))
        //     ? ""
        //     :`ประกันทุพพลภาพ ควรซื้อเพิ่มอีกอย่างน้อย  ${numeral(
        //         Math.abs(DisableInsurancePDF(insuranceData))
        //       ).format("0,0")} บาท เพื่อให้คนที่คุณรักและห่วงใยดำรงชีพต่อไปได้` ,
        // desc:
        //   (DisableInsurancePDF(insuranceData) < 0 || !DisableInsurancePDF(insuranceData))? (
        //         <>
        //           <div className="text-start">
        //             คุณรักครอบครัวมาก มีการคุ้มครองมาดีแล้ว
        //             หากต้องคุ้มครองเป็นกองมรดกเพิ่ม ก็แล้วแต่ความเห็นสมควร
        //           </div>
        //         </>
        //       ) : (
        //         <>
        //           <div>
        //             {`ควรทบทวนประกันทุพพลภาพว่ามีเพียงพอหรือไม่  ถ้ายังไม่เพียงพอ เบี้ยประกันทุพพลภาพหลักพัน คุ้มครองหลักแสน เบี้ยประกันหลักหมื่นคุ้มครองหลักล้าน `}
        //           </div>
        //           <div>{`**กรอกข้อมูลได้ที่รายจ่ายคงที่ > ค่าเบี้ยประกันชีวิตรายปี > รายละเอียดเพิ่มเติม > ตามข้อมูลที่มีดอกจัน 1 ดอก**`}</div>
        //         </>

        //       ),
      },
      {
        label: "ประกันสุขภาพ",
        icon: "risk_sick.svg",
        desc:
          Number(
            HealthCheckPDF(balanceData)?.treatmentSurgery +
              HealthCheckPDF(balanceData)?.treatmentSurgeryLumpSum +
              HealthCheckPDF(balanceData)?.compensationtreatment +
              HealthCheckPDF(balanceData)?.compensationtreatmentSpacial
          ) <= 0 ? (
            <>
              <div className="text-start">
                {`คุณลืมกรอกข้อมูลค่าเบี้ยประกันชีวิตหรือไม่ ถ้าคุณไม่ได้ซื้อประกันสุขภาพ หากเกิดเหตุไม่คาดฝันขึ้นมา เจ็บป่วยครั้งเดียวแทบหมดตัว  เบี้ยประกันสุขภาพหลักพัน คุ้มครองหลักแสน เบี้ยประกันหลักหมื่นคุ้มครองหลักล้าน`}
              </div>
              <div>{`**กรอกข้อมูลได้ที่รายจ่ายคงที่ > ค่าเบี้ยประกันชีวิตรายปี > รายละเอียดเพิ่มเติม > ตามข้อมูลที่มีดอกจัน 2 ดอก**`}</div>
            </>
          ) : (
            <div className="flex flex-col items-start ">
              <div className="!font-medium !text-[10px]">{`การรักษาในโรงพยาบาลและศัลยกรรม  ${numeral(
                HealthCheckPDF(balanceData)?.treatmentSurgery
              ).format("0,0")} บาท   `}</div>{" "}
              <div className="!font-medium !text-[10px]">
                {`
การรักษาในโรงพยาบาลและศัลยกรรมแบบเหมาจ่าย  ${numeral(
                  HealthCheckPDF(balanceData)?.treatmentSurgeryLumpSum
                ).format("0,0")} บาท `}{" "}
              </div>{" "}
              <div className="!font-medium !text-[10px]">{`
ค่าชดเชยรายวันในการเข้ารักษาตัวในโรงพยาบาล แบบพิเศษ    ${numeral(
                HealthCheckPDF(balanceData)?.compensationtreatment
              ).format("0,0")} บาท `}</div>{" "}
              <div className="!font-medium !text-[10px]">{`ค่าชดเชยรายวันในการเข้ารักษาตัวในโรงพยาบาล ${numeral(
                HealthCheckPDF(balanceData)?.compensationtreatmentSpacial
              ).format("0,0")}
              บาท`}</div>
              <div className="flex flex-wrap justify-start">
                ควรทบทวนประกันสุขภาพว่ามีเพียงพอหรือไม่ ถ้ายังไม่เพียงพอ
                เบี้ยประกันสุขภาพหลักพัน คุ้มครองหลักแสน
              </div>
            </div>
          ),
      },
      {
        label: "ประกันอุบัติเหตุ",
        icon: "risk_accident.svg",
        value_more: `คุณมีประกันอุบัติเหตุแล้ว ${numeral(
          accidentInsurancValue
        ).format("0,0")} บาท`,
        desc: hasAccidentInsurance ? (
          <div>
            <div>
              ควรทบทวนกรมธรรม์ประกันอุบัติเหตุ
              ว่ามีความคุ้มครองเพียงพอต่อความจำเป็นหรือไม่
              เบี้ยหลักพันคุ้มครองหลักแสน
              เบิกได้ทั้งอุบัติเหตุผู้ป่วยในและผู้ป่วยนอก รักษาจนกว่าจะหาย
              ตามวงเงินประกัน
            </div>
          </div>
        ) : (
          <>
            <div>
              ประกันอุบัติเหตุเบี้ยหลักพันต่อปีคุ้มครองหลักแสน มีแล้วอุ่นใจ
              เบิกได้ทั้งอุบัติเหตุผู้ป่วยในและผู้ป่วยนอก รักษาจนกว่าจะหาย
              ตามวงเงินประกัน
            </div>
            <div>{`**กรอกข้อมูลได้ที่รายจ่ายคงที่ > ค่าเบี้ยประกันอุบัติเหตุรายปี > ทุนประกัน**`}</div>
          </>
        ),
      },
      {
        label: "ประกันสินทรัพย์อัคคีภัย",
        icon: "insurance_house.svg",
        value_more: `คุณมีประกันสินทรัพย์อัคคีภัยแล้ว ${numeral(
          fireInsuranceValue
        ).format("0,0")} บาท`,
        desc: hasFireInsurance ? (
          <p>
            ควรทบทวนกรมธรรม์ ประกันสินทรัพย์และอัคคีภัย
            ว่าได้รับความคุ้มครองเหมาะสมกับมูลค่าสินทรัพย์ในปัจจุบันหรือไม่
            มิฉะนั้นหากเกิดความเสียหายมา บริษัทจะจ่ายตามสัดส่วน
            ไม่ใช่มูลค่าความเสียหายที่แท้จริง
          </p>
        ) : (
          <>
            <div>
              สินทรัพย์ของคุณยังไม่มีการบริหารความเสี่ยงด้วยประกันอัคคีภัย
              เบี้ยหลักพันคุ้มครองหลักล้าน
            </div>
            <div>{`**กรอกข้อมูลได้ที่รายจ่ายคงที่ > ค่าเบี้ยประกันสินทรัพย์สินและอัคคีภัยรายปี > ทุนประกัน**`}</div>
          </>
        ),
      },
      {
        label: "ประกันรถยนต์",
        icon: "car_insuarance_all.png",
        value_more: `คุณมีประกันรถยนต์แล้ว ${numeral(carInsuranceValue).format(
          "0,0"
        )} บาท`,
        desc: hasCarInsurance ? (
          <p>
            ควรทบทวนกรมธรรม์ประกันอุบัติเหตุ
            ว่ามีความคุ้มครองเพียงพอต่อความจำเป็นหรือไม่
            เบี้ยหลักพันคุ้มครองหลักแสน
            เบิกได้ทั้งอุบัติเหตุผู้ป่วยในและผู้ป่วยนอก รักษาจนกว่าจะหาย
            ตามวงเงินประกัน
          </p>
        ) : (
          <>
            <div>
              คุณลืมกรอกข้อมูลค่าเบี้ยประกันรถยนต์หรือไม่
              ถ้าคุณไม่ได้ซื้อประกันรถยนต์ภาคบังคับ/ภาคสมัครใจ
              หากเกิดเหตุไม่คาดฝันขึ้นมา โดนฟ้องร้องหมดตัวเลยนะครับ
              เบี้ยประกันภาคบังคับหลักร้อยต่อปีคุ้มครองหลักแสน ประกันภาคสมัครใจ
              เบี้ยหลักพันคุ้มครองหลักแสน
            </div>
            <div>{`**กรอกข้อมูลได้ที่รายจ่ายคงที่ > ค่าเบี้ยประกันรถยนต์รายปี > ทุนประกัน**`}</div>
          </>
        ),
      },
    ];
    return newInsuranceItems;
  }, [riskData]);

  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText title="บริหารความเสี่ยง" icon="/images/payment_pdf.svg" />

      {/* ประกันที่ควรมี */}
      <PdfCard
        className={"flex flex-col space-y-2"}
        classNameTitle={"mb-[5px]"}
        title={"ประกันที่ควรมี "}
      >
        {/* ประกันที่ควรมี 1 */}
        <div className="grid grid-cols-1 gap-2">
          {order === 1 && insuranceItems?.slice(0, 3)?.map((item, index) => {
            return (
              <PdfCardWhite key={index} className={"flex flex-col p-[5px]"}>
                <div className="flex items-center  mx-1">
                  <div>
                    <img
                      src={`/images/${item.icon}`}
                      className="w-[18px] h-[18px]"
                    />
                  </div>
                  <div className="ml-1 font-[500] text-[11px] my-1">
                    {item.label}
                  </div>
                </div>
                <div className={"font-[500] text-[10px]"}>
                  {item.value_more}
                </div>
                <div className={cn(STYLE_PDF_TEXT_NORMAL_10, " text-center")}>
                  {item.desc}
                </div>
              </PdfCardWhite>
            );
          })}
          {order === 2 && insuranceItems?.slice(4, 6)?.map((item, index) => {
            return (
              <PdfCardWhite key={index} className={"flex flex-col p-[5px]"}>
                <div className="flex items-center  mx-1">
                  <div>
                    <img
                      src={`/images/${item.icon}`}
                      className="w-[18px] h-[18px]"
                    />
                  </div>
                  <div className="ml-1 font-[500] text-[11px] my-1">
                    {item.label}
                  </div>
                </div>
                <div className={"font-[500] text-[10px]"}>
                  {item.value_more}
                </div>
                <div className={cn(STYLE_PDF_TEXT_NORMAL_10, " text-center")}>
                  {item.desc}
                </div>
              </PdfCardWhite>
            );
          })}
        </div>

        {/* ประกันที่ควรมี 2 */}
        {/* <div className="grid grid-cols-2 gap-2">
          {insurance2Items?.map((item, index) => {
            return (
              <PdfCardWhite key={index} className={"flex flex-col p-[5px]"}>
                <div className="flex items-center  mx-1">
                  <div>
                    <img
                      src={`/images/${item.icon}`}
                      className="w-[18px] h-[18px]"
                    />
                  </div>
                  <div className="ml-1 font-[500] text-[11px] my-1">
                    {item.label}
                  </div>
                </div>
                <div className={cn(STYLE_PDF_TEXT_NORMAL_10, "text-center")}>
                  {item.desc}
                </div>
              </PdfCardWhite>
            );
          })}
        </div> */}
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default PdfPageRiskTwo;
